// extracted by mini-css-extract-plugin
export default {"horizontal":"Timeline_horizontal__JEU2j"};